import { theme } from 'configs/styled';
import TextRegular from 'containers/DriverPortalPage/components/TextRegular';
import Title from 'containers/DriverPortalPage/components/Title';
import React from 'react';

interface IInformation {
  title: string;
  description: string;
}

const Information: React.FC<IInformation> = props => {
  const { title, description } = props;
  return (
    <div style={{ marginBottom: theme.spacing.xl }}>
      <Title>{title}</Title>
      <TextRegular>{description}</TextRegular>
    </div>
  );
};

export default Information;
